import { render, staticRenderFns } from "./FreeConsulting.vue?vue&type=template&id=967ed71a&scoped=true"
import script from "./FreeConsulting.vue?vue&type=script&lang=js"
export * from "./FreeConsulting.vue?vue&type=script&lang=js"
import style0 from "./FreeConsulting.vue?vue&type=style&index=0&id=967ed71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967ed71a",
  null
  
)

export default component.exports